import React from 'react'

export type ThumbsDownIconProps = {
  size?: number
  /** Stroke color. Defaults to `currentColor` so the parent controls theming. */
  color?: string
  className?: string
}

export const ThumbsDownIcon = ({
  size = 15,
  color = 'currentColor',
  className,
}: ThumbsDownIconProps) => (
  <svg
    aria-label='Thumbs down'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 15 15'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.625 8.125V2.5M10.625 8.125H12.5C12.6658 8.125 12.8247 8.05915 12.9419 7.94194C13.0592 7.82473 13.125 7.66576 13.125 7.5V3.125C13.125 2.95924 13.0592 2.80027 12.9419 2.68306C12.8247 2.56585 12.6658 2.5 12.5 2.5H10.625M10.625 8.125L8.125 12.5C7.79348 12.5 7.47554 12.3683 7.24112 12.1339C7.0067 11.8995 6.875 11.5815 6.875 11.25V9.375H3.4375C3.30049 9.37525 3.16508 9.34546 3.04082 9.28773C2.91656 9.23 2.80646 9.14574 2.71828 9.04088C2.6301 8.93601 2.56597 8.81309 2.53042 8.68077C2.49487 8.54845 2.48875 8.40994 2.5125 8.275L3.2625 4.2125C3.18408 4.01676 3.15645 3.80436 3.18218 3.59507C3.20792 3.38578 3.28618 3.1864 3.40968 3.01548C3.53319 2.84457 3.69793 2.70768 3.88856 2.61755C4.0792 2.52742 4.28953 2.48698 4.5 2.5H10.625'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.25}
    />
  </svg>
)
